module.exports = __webpack_public_path__ + "img/plane.2306ffda.webp";